module.exports = __webpack_public_path__ + "static/img/home-1-background.1ba35520.jpg";